import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  withArrow?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  withArrow = false,
  className = '',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-exclusive hover:bg-[#8A3DFF] text-white focus:ring-exclusive shadow-[0_4px_14px_0_rgba(157,77,255,0.39)] hover:shadow-[0_6px_20px_rgba(157,77,255,0.23)] hover:-translate-y-0.5',
    secondary: 'bg-neon hover:bg-[#A5FF00] text-base focus:ring-neon shadow-[0_4px_14px_0_rgba(182,255,26,0.39)] hover:shadow-[0_6px_20px_rgba(182,255,26,0.23)] hover:-translate-y-0.5',
    outline: 'border-2 border-neon text-neon hover:bg-neon/10 focus:ring-neon'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  return <motion.button whileTap={{
    scale: 0.98
  }} className={classes} {...props} data-id="element-332">
      {children}
      {withArrow && <ArrowRight className="ml-2 w-5 h-5" data-id="element-333" />}
    </motion.button>;
}